export class AwarsEgr{
    id: number;
    nombre: String;
}